export const LAST_PUBLICATION_COMMENT_ITEM = {
  article: 'Статья',
  errorInData: '<ошибка в данных>',
  news: 'Новость'
}
